module.exports = __webpack_public_path__ + "img/4-2.35cb40b7.svg";